import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { avatarConfig, tokens } from '../../constants';
import { fitContentWidth } from '../../utils';
var getOuterContainerStyle = props => {
  var _a, _b, _c;
  var avatarSize = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b[props === null || props === void 0 ? void 0 : props.size]) === null || _c === void 0 ? void 0 : _c.avatarSize;
  return {
    height: avatarSize,
    width: avatarSize,
    justifyContent: 'center',
    alignItems: 'center'
  };
};
var getContainerBasicStyle = props => {
  var _a, _b, _c;
  var config = props.config,
    size = props.size,
    _props$status = props.status,
    status = _props$status === void 0 ? 'default' : _props$status;
  var avatarSize = (_b = (_a = config === null || config === void 0 ? void 0 : config.size) === null || _a === void 0 ? void 0 : _a[size]) === null || _b === void 0 ? void 0 : _b.avatarSize;
  var variant = props.variant,
    noBgContainer = props.noBgContainer;
  var showBackgroundColor = variant == 'initials' || variant == 'icon';
  var avatarStatusColor = (_c = config === null || config === void 0 ? void 0 : config.state) === null || _c === void 0 ? void 0 : _c[status];
  var backgroundColor = avatarStatusColor === null || avatarStatusColor === void 0 ? void 0 : avatarStatusColor.backgroundColor;
  if (noBgContainer) return fitContentWidth();
  return Object.assign(Object.assign({
    height: avatarSize,
    width: avatarSize,
    borderRadius: tokens.borderRadius.BORDER_RADIUS_100,
    justifyContent: 'center',
    alignItems: 'center'
  }, showBackgroundColor && {
    backgroundColor
  }), {
    overflow: 'hidden'
  });
};
var getDotMargin = size => {
  var dotTopMargin = 0;
  var dotRightMargin = 0;
  switch (size) {
    case 'xxs':
      {
        dotTopMargin = 2;
        dotRightMargin = -2;
        break;
      }
    case 'xs':
      {
        dotTopMargin = 1;
        dotRightMargin = -1;
        break;
      }
    case 'sm':
      {
        dotTopMargin = 1;
        dotRightMargin = 1;
        break;
      }
    case 'md':
      {
        dotTopMargin = 2;
        dotRightMargin = 0;
        break;
      }
    case 'lg':
      {
        dotTopMargin = 4;
        dotRightMargin = 2;
        break;
      }
    case 'xl':
      {
        dotTopMargin = 7;
        dotRightMargin = 4;
        break;
      }
    case 'xxl':
      {
        dotTopMargin = 8;
        dotRightMargin = 8;
        break;
      }
  }
  return {
    top: dotTopMargin,
    right: dotRightMargin
  };
};
var getdotStyle = props => {
  var _getDotMargin = getDotMargin(props === null || props === void 0 ? void 0 : props.size),
    top = _getDotMargin.top,
    right = _getDotMargin.right;
  return {
    position: 'absolute',
    top,
    right
  };
};
var getNotifierStyles = () => {
  return {
    position: 'absolute',
    top: -1,
    right: 0
  };
};
var getImageStyle = () => {
  return {
    width: '100%',
    height: '100%',
    overflow: 'hidden'
  };
};
var getSvgStyle = props => {
  var _a, _b, _c;
  var iconSize = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b[props === null || props === void 0 ? void 0 : props.size]) === null || _c === void 0 ? void 0 : _c.iconSize;
  return {
    width: iconSize,
    height: iconSize,
    borderRadius: tokens.borderRadius.BORDER_RADIUS_100
  };
};
export var getLabelTypes = size => {
  var labelTypes = {
    xxs: 'body-single-line-xxs',
    xs: 'body-single-line-xs',
    sm: 'body-single-line-sm',
    md: 'body-single-line-md',
    lg: 'body-single-line-lg',
    xl: 'body-single-line-xl',
    xxl: 'body-single-line-xl'
  };
  return labelTypes === null || labelTypes === void 0 ? void 0 : labelTypes[size];
};
export var getAvatarStyles = props => {
  return StyleSheet.create({
    outerContainer: getOuterContainerStyle(props),
    container: getContainerBasicStyle(props),
    dot: getdotStyle(props),
    notifier: getNotifierStyles(),
    image: getImageStyle(),
    svg: getSvgStyle(props)
  });
};
export var getAvatarProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(avatarConfig === null || avatarConfig === void 0 ? void 0 : avatarConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.avatar) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};